// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3mC38","colMaxWidth":"Table_colMaxWidth__3apxo"};